"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUpGUComponents = void 0;
const constants_1 = require("./constants");
const exec_1 = require("@actions/exec");
const path_1 = require("path");
const COMPONENT_TO_POST_INSTALL_HOOK = new Map([
    [
        'linux',
        new Map([
            ['ruby', 'languages/ruby/lib/truffle/post_install_hook.sh']
            // ['R', 'languages/R/bin/configure_fastr'] (GR-36105: cannot be run non-interactively)
        ])
    ],
    [
        'darwin',
        new Map([
            ['ruby', 'languages/ruby/lib/truffle/post_install_hook.sh']
            // ['R', 'languages/R/bin/configure_fastr'] (GR-36105: cannot be run non-interactively)
        ])
    ]
    // No post install hooks for Windows (yet)
]);
function setUpGUComponents(graalVMHome, components) {
    return __awaiter(this, void 0, void 0, function* () {
        yield (0, exec_1.exec)('gu', ['install', '--no-progress'].concat(components));
        const platformHooks = COMPONENT_TO_POST_INSTALL_HOOK.get(constants_1.GRAALVM_PLATFORM);
        if (platformHooks) {
            for (const component of components) {
                const postInstallHook = platformHooks.get(component);
                if (postInstallHook) {
                    yield (0, exec_1.exec)(`"${(0, path_1.join)(graalVMHome, postInstallHook)}"`);
                }
            }
        }
    });
}
exports.setUpGUComponents = setUpGUComponents;
